<template>
  <div class="page-wrapper d-flex">
    <header id="wrapper-header" style="background: white">
      <div id="header-before">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <ul>
                <li>
                  <span class="fa fa-clock-o"></span> Pracujemy od 8.00 do 16.00
                </li>
                <li>
                  <span class="fa fa-phone"></span>
                  <a href="tel:+48618209900">+48 61 82 09 900</a>
                </li>
                <li>
                  <span class="fa fa-envelope"></span>
                  <a href="mailto:kontakt@dialtech.pl">kontakt@dialtech.pl</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div id="header">
        <div class="container">
          <div class="row justify-content-between align-items-end">
            <div id="header-logo" class="col-12">
              <a href="http://dialtech.pl">
                <img
                  src="/img/logo-dialtech.png"
                  class="img-fluid mx-auto d-block"
                  alt="Dialtech"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div id="header-after">
        <div class="container">
          <div class="row">
            <div id="navigation" class="col-12">
              <nav class="navbar navbar-expand-lg navbar-light">
                <button
                  class="navbar-toggler btn btn-exclusive mx-auto"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navigation-header"
                  aria-controls="navigation-header"
                  aria-expanded="false"
                  aria-label="MENU"
                >
                  MENU
                </button>
                <div class="collapse navbar-collapse" id="navigation-header">
                  <ul class="navbar-nav justify-content-between">
                    <li class="nav-item first">
                      <a href="https://dialtech.pl/o-firmie/" class="nav-link">O firmie</a>
                    </li>
                    <li class="nav-item">
                      <a href="https://dialtech.pl/oferta/" class="nav-link">Oferta</a>
                    </li>
                    <li class="nav-item">
                      <a href="/" class="nav-link">Zamów kartę</a>
                    </li>
                    <li class="nav-item">
                      <a href="https://dialtech.pl/doladowania/" class="nav-link">Doładowania</a>
                    </li>
                    <li class="nav-item">
                      <a href="https://dialtech.pl/cenniki/" class="nav-link">Cenniki</a>
                    </li>
                    <li class="nav-item">
                      <a href="https://dialtech.pl/regulamin/" class="nav-link">Regulaminy</a>
                    </li>
                    <li class="nav-item">
                      <a href="https://dialtech.pl/kontakt/" class="nav-link">Kontakt</a>
                    </li>
                    <li class="nav-item last">
                      <a href="https://dialtech.pl/punkty-sprzedazy/" class="nav-link"
                        >Punkty sprzedaży</a
                      >
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
    <transition name="fade" mode="out-in">
      <router-view v-if="isLoaded" />
    </transition>
    <footer class="page-footer">
      <div class="container">
        <p>Dialtech<br />Wszystkie prawa zastrzeżone!</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",

  data: function () {
    return {
      isLoaded: false,
    };
  },

  created() {
    this.$store.dispatch("getProducts").then(() => {
      if (
        this.$route.query.buy_product != null &&
        this.$route.query.buy_quantity != null &&
        Number.isInteger(parseInt(this.$route.query.buy_product)) &&
        Number.isInteger(parseInt(this.$route.query.buy_quantity)) &&
        this.$route.query.buy_quantity > 0 &&
        this.$route.query.buy_product > 0
      ) {
        this.$store.commit("updateCountById", {
          index: this.$route.query.buy_product,
          count: this.$route.query.buy_quantity,
        });
        this.$router.replace({ name: "Cart" });
        this.isLoaded = true;
      } else {
        if (this.$router.currentRoute.name != "ProductList") {
          this.isLoaded = true;
          this.$router.replace({ name: "ProductList" });
        }
      }
      this.$store.dispatch("getLetterOptions");
      this.isLoaded = true;
    });
  },

  mounted() {},
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Ubuntu:wght@300&display=swap");
@font-face {
  font-family: "FontAwesome";
  src: url("/fonts/fontawesome-webfont.eot?v=4.7.0");
  src: url("/fonts/fontawesome-webfont.eot?#iefix&v=4.7.0")
      format("embedded-opentype"),
    url("/template/fonts/fontawesome-webfont.woff2?v=4.7.0")
      format("woff2"),
    url("/fonts/fontawesome-webfont.woff?v=4.7.0") format("woff"),
    url("http://prhz.pl/dialtech/template/plugins/fontawesome4/fonts/fontawesome-webfont.ttf?v=4.7.0")
      format("truetype");
  font-weight: normal;
  font-style: normal;
}
.page-wrapper {
  min-height: 100vh;
  background: url(/img/selling-points.png) 0px 285px repeat-y;
}


// .header-nav {
//   font-family: "Open Sans Condensed", sans-serif;
//   font-size: 20px;

//   a {
//     color: #312783 !important;
//   }

//   a.active,
//   a:hover {
//     color: #ff6c00 !important;
//   }
// }

.page-wrapper {
  flex-direction: column;
}

.wrapper-header{
  background: white;
}

.page-footer {
  font-size: 10px;
  line-height: 12px;
  padding: 20px 0px;
  background: #d4d4d4;
  margin-top: auto;

  p {
    margin-bottom: 0px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
